var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34699 8.01327H26.6803V10.6799H5.34699V8.01327ZM8.01366 2.67993H24.0137V5.3466H8.01366V2.67993ZM26.667 13.3333H5.33366C4.62641 13.3333 3.94814 13.6142 3.44804 14.1143C2.94794 14.6144 2.66699 15.2927 2.66699 15.9999V26.6666C2.66699 27.3738 2.94794 28.0521 3.44804 28.5522C3.94814 29.0523 4.62641 29.3333 5.33366 29.3333H26.667C27.3742 29.3333 28.0525 29.0523 28.5526 28.5522C29.0527 28.0521 29.3337 27.3738 29.3337 26.6666V15.9999C29.3337 15.2927 29.0527 14.6144 28.5526 14.1143C28.0525 13.6142 27.3742 13.3333 26.667 13.3333ZM13.7337 26.6666L9.33366 22.3466L11.2003 20.4799L13.7337 23.0133L20.8003 15.9466L22.667 17.8133L13.7337 26.6666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreated);
export default __webpack_public_path__ + "static/media/Created.a90952e422c88dc4252c7c20ce1fa838.svg";
export { ForwardRef as ReactComponent };